/**
 * Dial codes (without +) for which SMS OTP delivery is enabled.
 * Update this set when a new country's SMS gateway is provisioned.
 * MY=60, PH=63, IN=91
 */
export const SMS_ENABLED_DIAL_CODES = new Set(['60', '63', '91']);

/** Returns true when SMS OTP should be available for the given dial code. */
export function isSmsEnabledForCountry(
  dialCode: string | null | undefined
): boolean {
  const normalized = (dialCode ?? '').replace('+', '');
  return Boolean(normalized) && SMS_ENABLED_DIAL_CODES.has(normalized);
}
